import { render, staticRenderFns } from "./StandardPagination.vue?vue&type=template&id=0c026fd8&"
import script from "./StandardPagination.vue?vue&type=script&lang=js&"
export * from "./StandardPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports